import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import {
  reorderRoute,
  getRoutesByDate,
} from './routeOptimizationActions';

import {
  CompareModal,
  CompareModalContent,
  CompareModalHeader,
  CompareModalTitle,
  StrategiesGrid,
  StrategyCard,
  StrategyName,
  StrategyStats,
  StrategyStat,
  StatLabel,
  StatValue,
} from './routeOptimizationStyles';

import { CloseButton, PrimaryButton } from '../../styledComponents/buttons';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';

function CompareStrategiesModal({
  routeId,
  organizationId,
  onClose,
  comparisonData,
  isComparing,
  isReordering,
  selectedDate,
  reorderRoute,
  getRoutesByDate,
}) {
  const handleApplyStrategy = (strategy) => {
    reorderRoute({
      organization_id: organizationId,
      route_id: routeId,
      job_sequence_ids: strategy.sequence,
    });

    // Refresh routes after reordering
    setTimeout(() => {
      if (selectedDate) {
        getRoutesByDate({
          organization_id: organizationId,
          date: selectedDate,
        });
      }
      onClose();
    }, 1000);
  };

  if (isComparing) {
    return (
      <CompareModal>
        <CompareModalContent>
          <ComponentCircleLoader />
        </CompareModalContent>
      </CompareModal>
    );
  }

  if (!comparisonData) {
    return null;
  }

  const strategies = [
    { key: 'current', label: 'Current Route', data: comparisonData.current },
    { key: 'shortest_distance', label: 'Shortest Distance', data: comparisonData.shortest_distance },
    { key: 'balanced', label: 'Balanced', data: comparisonData.balanced },
    { key: 'fastest', label: 'Fastest', data: comparisonData.fastest },
  ];

  return (
    <CompareModal onClick={onClose}>
      <CompareModalContent onClick={(e) => e.stopPropagation()}>
        <CompareModalHeader>
          <CompareModalTitle>Compare Optimization Strategies</CompareModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </CompareModalHeader>

        <StrategiesGrid>
          {strategies.map(({ key, label, data }) => (
            <StrategyCard key={key} isActive={key === 'current'}>
              <StrategyName>{label}</StrategyName>
              
              <StrategyStats>
                <StrategyStat>
                  <StatLabel>Distance:</StatLabel>
                  <StatValue>{data.distance_km.toFixed(1)} km</StatValue>
                </StrategyStat>
                
                <StrategyStat>
                  <StatLabel>Duration:</StatLabel>
                  <StatValue>{data.duration_min} min</StatValue>
                </StrategyStat>
                
                <StrategyStat>
                  <StatLabel>Score:</StatLabel>
                  <StatValue>{data.optimization_score.toFixed(1)}</StatValue>
                </StrategyStat>
              </StrategyStats>

              {key !== 'current' && (
                <PrimaryButton
                  onClick={() => handleApplyStrategy(data)}
                  disabled={isReordering}
                  style={{ marginTop: '10px', width: '100%' }}
                >
                  {isReordering ? 'Applying...' : 'Apply Strategy'}
                </PrimaryButton>
              )}

              {key === 'current' && (
                <div style={{
                  marginTop: '10px',
                  padding: '8px',
                  backgroundColor: '#e3f2fd',
                  borderRadius: '4px',
                  textAlign: 'center',
                  fontSize: '12px',
                  fontWeight: '600',
                  color: '#1976d2',
                }}>
                  Current Active
                </div>
              )}
            </StrategyCard>
          ))}
        </StrategiesGrid>
      </CompareModalContent>
    </CompareModal>
  );
}

const mapStateToProps = (state) => ({
  comparisonData: state.RouteOptimization.comparisonData,
  isComparing: state.RouteOptimization.isComparing,
  isReordering: state.RouteOptimization.isReordering,
  selectedDate: state.RouteOptimization.selectedDate,
});

const mapDispatchToProps = {
  reorderRoute,
  getRoutesByDate,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareStrategiesModal);

